/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const PopupWrap = styled.div`
  padding: 8px;
  background: white;
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  box-shadow: rgba(23, 43, 77, 0.08) 0px 16px 32px 0px, rgba(23, 43, 77, 0.04) 0px 16px 24px 0px;
  z-index: 2200;
`;
